class ProductFormVariants extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-', '');

    const elements = {
      form: this.closest("form"),
      inputs: this.querySelectorAll('input[type="radio"]')
    };

    const params = new URLSearchParams(window.location.search);
    if (params.get('variant')) {
      this.classList.add('variant-selected');
    }

    elements.inputs.forEach((element) => {
      element.addEventListener('click', () => {
        const variant = get_variant();

        if (!variant) {
          return;
        }

        document.dispatchEvent(new CustomEvent("productformvariants:change", {
          detail: {
            variant: variant
          }
        }));

        Theme.URLParams.set("variant", variant.id);

        elements.form.querySelector("[name=id]").value = variant.id;

        if (variant && variant.id) {
          this.onVariantChange(variant.id);
        }
      });
    });

    const get_variant = () => {
      const variant_title = get_variant_title(elements.inputs);
      const variant = get_variant_by_title(variant_title);
      return variant;
    };

    const get_variant_title = (form_elements) => {
      let selectedValues = [];
      form_elements.forEach(el => {
        if (el.type === "radio" && el.checked) {
          selectedValues.push(el.value);
        }
      });
      const title = selectedValues.join(" / ").trim();
      return title;
    };

    const get_variant_by_title = (title) => {
      let selectedVariant = null;
      Theme.Liquid.product.variants.forEach((variant) => {
        if (title === variant.title) {
          selectedVariant = variant;
        }
      });
      return selectedVariant;
    };
    const variantDropdowns = this.querySelectorAll('.variants-dropdown');
    if (variantDropdowns.length > 0) {
      this.initVariantsDropdown();
    }
  }

  disconnectedCallback() {
    if (this._onDocumentClick) {
      document.removeEventListener('click', this._onDocumentClick);
      this._onDocumentClick = null;
    }
  }

  onVariantChange(variantId) {
    if (!variantId || !this.sectionId) {
      return;
    }

    this.classList.add('variant-selected');

    const url = `${window.location.pathname}?variant=${variantId}&section_id=${this.sectionId}`;

    fetch(url)
      .then(res => res.text())
      .then(text => {
        return text;
      })
      .then(html => {
        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newSection = doc.querySelector(`#shopify-section-${this.sectionId}`);
          const currentSection = document.querySelector(`#shopify-section-${this.sectionId}`);

          if (newSection && currentSection) {
            currentSection.replaceWith(newSection);

            const next = document.querySelector(`#shopify-section-${this.sectionId} product-form-variants`);
            if (next) {
              next.classList.add('variant-selected');
            }
          }

          if (typeof productTabs === "function") {
            productTabs();
          }

        } catch (error) {
        }
      })
      .catch(error => {
      });
  }

  initVariantsDropdown() {
    const dropdowns = this.querySelectorAll('.variants-dropdown');

    if (!this._onDocumentClick) {
      this._onDocumentClick = (e) => {
        const dropdown = e.target.closest('.variants-dropdown');
        if (dropdown && this.contains(dropdown)) {
          return;
        }

        const openLists = this.querySelectorAll('.variants-dropdown.is-open');
        openLists.forEach((openList) => {
          openList.classList.remove('is-open');
        });
      };

      document.addEventListener('click', this._onDocumentClick);
    }

    dropdowns.forEach((dropdown, index) => {

      const trigger = dropdown.querySelector('.variants-dropdown-trigger');
      const list = dropdown.querySelector('.variants-dropdown-list');

      if (!trigger) {
        return;
      }

      if (!list) {
        return;
      }

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = dropdown.classList.contains('is-open');

        const openLists = this.querySelectorAll('.variants-dropdown.is-open');
        openLists.forEach(openList => {
          if (openList !== dropdown) {
            openList.classList.remove('is-open');
          }
        });

        dropdown.classList.toggle('is-open', !isOpen);
      });

      list.addEventListener('click', (e) => {
        e.stopPropagation();
        const label = e.target.closest('label');
        if (!label) {
          return;
        }

        const input = dropdown.querySelector(`input[type="radio"][value="${label.querySelector('input[type="radio"]').value}"]`);
        if (input) {
          input.click();
        }

        dropdown.classList.remove('is-open');
      });

    });
  }
}



customElements.define("product-form-variants", ProductFormVariants)


class ProductFormVariantsCard extends HTMLElement {
  constructor() {
    super();

    const dropdowns = this.querySelectorAll('.variants-dropdown-card');

    this.addEventListener('click', (e) => {
      const trigger = e.target.closest('.variants-dropdown-card-trigger');
      if (trigger) {
        e.preventDefault();
        const dropdown = trigger.closest('.variants-dropdown-card');
        dropdowns.forEach(otherDropdown => {
          if (otherDropdown !== dropdown) {
            otherDropdown.classList.remove('is-open');
          }
        });
        dropdown.classList.toggle('is-open');
        return;
      }

      const label = e.target.closest('.variants-dropdown-card-list label');
      if (label) {
        const dropdown = label.closest('.variants-dropdown-card');
        const form = dropdown.closest('form');
        const inputId = label.getAttribute('for');
        const input = inputId ? dropdown.querySelector('#' + CSS.escape(inputId)) : null;
        if (input) {
          input.checked = true;
          const trig = dropdown.querySelector('.variants-dropdown-card-trigger');
          if (trig) {
            const span = trig.querySelector('span');
            if (span) {
              span.textContent = label.textContent.trim();
            }
          }
          if (form) {
            const hiddenInput = form.querySelector('[name=id]');
            if (hiddenInput && input.dataset.variantId) {
              hiddenInput.value = input.dataset.variantId;
            }
          }
        }
        dropdown.classList.remove('is-open');
        return;
      }

      if (!e.target.closest('.variants-dropdown-card')) {
        dropdowns.forEach(dropdown => {
          dropdown.classList.remove('is-open');
        });
      }
    });
  }
}

customElements.define('product-form-variants-card', ProductFormVariantsCard);
